import astron from './astron.config';
import itex from './itex.config';

const BRAND = import.meta.env.VITE_BRAND_NAME || 'ASTRON';

const registry = {
  ASTRON: astron,
  ITEX: itex,
};

export const brandConfig = registry[BRAND];

if (!brandConfig) {
  throw new Error(`Unknown brand: ${BRAND}`);
}
